import _extends from '@babel/runtime/helpers/extends';
import { colors } from '../constants/colors.js';
var sliderThemeWeb = {
  color: 'primary',
  disabled: colors.fogGrey,
  height: 4,
  label: {
    color: colors.octoberGrey
  },
  valueIndicator: {
    background: colors.inkGrey,
    color: colors.snowWhite
  },
  rail: {
    inactive: colors.fogGrey,
    targetableHeight: 24
  },
  circle: {
    diameter: 24,
    focusHighlightColor: colors.snowWhite
  }
};
var sliderThemeNative = {
  color: 'primary',
  disabled: colors.fogGrey,
  height: 4,
  label: {
    color: colors.octoberGrey,
    offset: 12
  },
  valueIndicator: {
    background: colors.inkGrey,
    color: colors.snowWhite,
    offset: 56,
    triangleWidth: 8
  },
  rail: {
    inactive: colors.fogGrey,
    targetableHeight: 44
  },
  circle: {
    diameter: 24
  }
};

var sliderDarkThemeNative = _extends({}, sliderThemeNative, {
  disabled: colors.inkGrey,
  label: _extends({}, sliderThemeNative.label, {
    color: colors.fogGrey
  }),
  valueIndicator: _extends({}, sliderThemeNative.valueIndicator, {
    background: colors.cloudGrey,
    color: colors.inkGrey
  }),
  rail: _extends({}, sliderThemeNative.rail, {
    inactive: colors.inkGrey
  })
});

export { sliderDarkThemeNative, sliderThemeNative, sliderThemeWeb };